import './MeteredUsagePage.css';
import { connect } from 'react-redux';
import { t } from 'i18next';
import React from 'react';
import BarChart from '../../reports/barChartReport/BarChartReport';
import EnhancedLineChart from '../../reports/enhancedLineChart/EnhancedLineChart';
import FilterPanel, { oem_id } from '../../filters/filterPanel/FilterPanel';
import Loading from '../../loading/Loading';
import { meteredUsageSelector } from '../../../reducer/selectors/meteredUsageSelector';
import {
  transactionByTypeDuringTransactionPeriod, numberOfTransactionDuringContractOverTime,
  deviceActiveDuringContractTerm, devicesOnlineToday, averageDailyTransactionActiveDevice,
  transactionUsed, averageAnnualTransactionPerActiveDevice, listOfOems,
  activatedDevices, totalDatapoints,
} from '../../../services/reportsservice';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import MultivalueDisplay from '../../reports/multivalueDisplayReport/MultivalueDispalyReport';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {logPageViewEvent} from "../../../services/analyticsservice";


class MeteredUsage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.MeteredUsage.title, logged_in_oem_id);
  }
  isContractDataRequired = true;

  reports() {
    const { filters, contractFilters } = this.props;
    return contractFilters ? {
      filters: [
        listOfOems(filters),
        // commenting as it has a dependency for reports/contract svc deployment
        // listOfRegions(filters)
      ],
      reports:
      [
        devicesOnlineToday(filters),
        activatedDevices(filters),
        totalDatapoints(filters),
        transactionByTypeDuringTransactionPeriod(contractFilters),
        deviceActiveDuringContractTerm(contractFilters),
        averageDailyTransactionActiveDevice(contractFilters),
        transactionUsed(contractFilters),
        averageAnnualTransactionPerActiveDevice(contractFilters),
        numberOfTransactionDuringContractOverTime(contractFilters),
      ],
    }
      : {
        filters: [
          listOfOems(filters),
          // commenting as it has a dependency for reports/contract svc deployment
          // listOfRegions(filters)
        ],
        reports:
        [
          devicesOnlineToday(filters),
          activatedDevices(filters),
          totalDatapoints(filters),

        ],
      };
  }

   reportsDescription = () => [
     numberOfTransactionDuringContractOverTime(),
     transactionByTypeDuringTransactionPeriod(),
   ];


   render() {
     const {
       fetchData, session, contractFilters, contractTerms,
     } = this.props;
     let pageContent;
     const usageDuringContractTerm = {
       'contract.devicesActiveDuringTerm': {
         type: 'strValue',
         value: this.report(deviceActiveDuringContractTerm),
       },
       'transactions.averageDailyPerDevice': {
         type: 'strValue',
         value: this.report(averageDailyTransactionActiveDevice),
       },
       'transactions.used': {
         color: '#F5A623',
         type: 'perValue',
         value: [
           this.report(transactionUsed),
           contractFilters ? contractFilters.purchased_transactions : null,
         ],
       },
       // eslint-disable-next-line sort-keys
       'transactions.averageAnnualPerDevice': {
         type: 'strValue',
         value: this.report(averageAnnualTransactionPerActiveDevice)
       },
     };

     if (contractFilters) {
       pageContent = (
         <>
           <div className="container-flex">
             <MultivalueDisplay title="contractTerms"
               data={contractTerms}
             />
             <MultivalueDisplay title="usageDuringContractTerm"
               data={usageDuringContractTerm}
               noBorder
             />
           </div>
           <div>
             <EnhancedLineChart title="devices.transactionUsageTrend"
               width={this.widthForColumns(1)}
               height={200}
               data={this.report(numberOfTransactionDuringContractOverTime)}
               description={this.reportDescription(numberOfTransactionDuringContractOverTime)}
               xLabel={this.props.presistFilters.aggregate_by}
               yLabel="transmissions"
             />
           </div>
           <div>
             <BarChart title="transactions.byTypeDuringContract"
               width={this.widthForColumns(1)}
               height={200}
               data={this.report(transactionByTypeDuringTransactionPeriod)}
               description={this.reportDescription(transactionByTypeDuringTransactionPeriod)}
               xLabel={this.props.presistFilters.aggregate_by}
               yLabel="devices"
             />
           </div>
         </>
       );
     } else if (! contractFilters && fetchData.fetches === 0) {
       pageContent = (<div className="no-contract-data">{t('noContractsData')}</div>);
     } else {
       pageContent = (<Loading size={60} />);
     }


     return (
       <div className="MeteredUsage page">
         <TitleBar title="meteredUsage">
           <TimeAggregation value={this.props.presistFilters.aggregate_by} />
         </TitleBar>
         <div className="pageContent">
           <FilterPanel disabled={fetchData.fetches > 0}
             currentFilters={this.props.presistFilters}
             filters={[
               AYLA_ALLOWED_ROLES.includes(session.role)
              && oem_id(this.report(listOfOems))
               // commenting as it has a dependency for reports/contract svc deployment
               // region_name(this.report(listOfRegions))
             ]}
           />
           { pageContent }

         </div>
       </div>


     );
   }
}

export default connect(state => meteredUsageSelector(state))(MeteredUsage);
